<article class="flex flex-col gap-8 overflow-hidden rounded-3xl bg-lGray900 p-6">
  <header class="flex items-start justify-between gap-4">
    <div class="flex flex-col gap-1">
      <h2 class="text-xl font-bold text-color">{{ modalTitle }}</h2>
      <p class="text-sm subtext-color">
        {{ isUpdate ? 'Atualize os dados da categoria' : 'Crie uma nova categoria para organizar cursos' }}
      </p>
    </div>

    <button
      type="button"
      class="p-1 text-lGray500 transition-colors hover:text-lGray300"
      (click)="close()"
    >
      <l-icon icon="close" class="text-2xl" />
    </button>
  </header>

  <form [formGroup]="formGroup" class="flex flex-col gap-6">
    <div class="flex justify-center py-1">
      <img
        src="assets/icons/books.svg"
        alt="Livros empilhados representando categorias"
        class="h-40 w-auto object-contain"
      />
    </div>

    <div class="grid gap-4 sm:grid-cols-[minmax(0,1fr)_88px] sm:items-end">
      <div class="flex flex-col gap-2">
        <label for="categoryName" class="text-sm font-medium text-lGray500">
          Categoria <span class="text-lDanger">*</span>
        </label>
        <div class="relative">
          <l-icon class="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-xl text-lGray600" icon="category" />
          <input
            id="categoryName"
            lInput
            formControlName="name"
            placeholder="Nome da categoria"
            class="pl-11 border-none"
            [ngClass]="{ '!border-lDanger': nameControl.invalid && nameControl.touched }"
          />
        </div>
      </div>

      <div class="flex flex-col gap-2 sm:justify-self-start">
        <label for="categoryColor" class="text-sm font-medium text-lGray500">Cor</label>
        <div class="relative inline-flex h-12 items-center gap-2 rounded-lg bg-lGray950 px-2">
          <l-icon icon="palette" class="pointer-events-none text-base text-lGray600" />

          <button
            id="categoryColor"
            type="button"
            class="h-7 w-7 rounded-full"
            [style.backgroundColor]="colorControl.value || '#F54297'"
            [colorPicker]="colorControl.value || '#F54297'"
            cpAlphaChannel="disabled"
            cpOutputFormat="hex"
            cpPosition="bottom"
            [cpOKButton]="true"
            cpOKButtonText="Aplicar"
            (colorPickerChange)="onColorPickerChange($event)"
            aria-label="Selecionar cor da categoria"
          ></button>
        </div>
      </div>
    </div>

    @if (nameControl.invalid && nameControl.touched) {
      <small class="-mt-2 text-xs text-lDanger">Nome é obrigatório</small>
    }

    @if (colorControl.invalid && colorControl.touched) {
      <small class="-mt-2 text-xs text-lDanger">Cor é obrigatória</small>
    }

    <div class="flex flex-col gap-2">
      <label for="categoryShortDescription" class="text-sm font-medium text-lGray500">Descrição curta</label>
      <div class="relative">
        <l-icon class="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-xl text-lGray600" icon="short_text" />
        <input
          id="categoryShortDescription"
          lInput
          formControlName="shortDescription"
          placeholder="Descreva brevemente a categoria"
          maxlength="80"
          class="pl-11 border-none"
        />
      </div>
    </div>

    <div class="flex flex-col gap-2">
      <label for="categoryDescription" class="text-sm font-medium text-lGray500">Descrição detalhada</label>
      <textarea
        id="categoryDescription"
        formControlName="description"
        placeholder="Descreva aqui os detalhes da categoria"
        [maxlength]="descriptionMax"
        rows="4"
        class="w-full rounded-lg bg-lGray950 px-4 py-3 text-base text-color placeholder:text-lGray600 focus:border-lPrimary focus:ring-1 focus:ring-lPrimary"
      ></textarea>
      <div class="text-right text-xs text-lGray500">{{ descriptionCount }} / {{ descriptionMax }}</div>
    </div>

    <div class="text-xs text-lDanger">(*) Campos obrigatórios</div>
  </form>
</article>

<div class="flex justify-center pt-2 mt-5">
  <button
    lButton
    type="button"
    [bType]="isDisabled ? buttonTypeEnum.DISABLED : buttonTypeEnum.PRIMARY"
    [bSize]="buttonSizeEnum.MEDIUM"
    [bRadius]="buttonRadiusEnum.LARGE"
    [disabled]="isDisabled"
    class="min-w-50"
    (click)="submit()"
  >
    @if (isSubmitting) {
      <l-spinner [color]="spinnerColorEnum.WHITE" [size]="spinnerSizeEnum.SMALL" />
    }

    {{ submitLabel }}
  </button>
</div>